export const config = {
    apiUrl: 'https://api.carnet-vocabulaire.ideereka.com/api'
};
